<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card id="srptCard">
        <v-card-text>
          <modalDialog :width="'80%'" ref="rptfm" :show="show_rpt" :pers="true">
            <template v-slot:modal-title>Report</template>

            <template v-slot:modal-content>
              <div style="text-align: center">
                <v-progress-linear
                  indeterminate
                  height="2"
                  v-show="rptloading"
                ></v-progress-linear>
                <h2>
                  {{ report_model.rpt_type ? report_model.rpt_type : "" }}
                  Report
                </h2>
                <h3>
                  From:
                  {{
                    moment(new Date(report_model.from)).format("DD-MMM-YYYY")
                  }}
                  To:
                  {{ moment(new Date(report_model.to)).format("DD-MMM-YYYY") }}
                </h3>
              </div>
              <v-card
                style="margin-bottom: 10px"
                v-if="report_model.rpt_type == 'Summary'"
                flat
              >
                <v-card-title>Summary</v-card-title>
                <v-card-text>
                  <div style="text-align: center">
                    <p>
                      Cash At Bank: GHS
                      {{
                        banktrans_data
                          ? banktrans_data.cash_at_bank
                          : 0 | currency
                      }}
                    </p>
                    <p>
                      Revenue (Sum of All Sales): GHS
                      {{
                        revenue_data
                          ? revenue_data.cash_sale_sum +
                            revenue_data.credit_sale_sum
                          : 0 | currency
                      }}
                    </p>
                    <p
                      v-if="
                        current_user.user_details &&
                        current_user.user_details.role === 'administrator'
                      "
                    >
                      Cost of Goods Sold : GHS
                      {{
                        revenue_data
                          ? revenue_data.goods_sold_cost_sum
                          : 0 | currency
                      }}
                    </p>
                    <p>
                      Expenses: GHS
                      {{
                        expenses_data ? expenses_data.ov_expense : 0 | currency
                      }}
                    </p>
                    <br />

                    <p style="font-style: italic; color: #333">
                      **NOTE: Accounts Receivable is already part of Revenue and
                      Accounts Payable is already part of expenses**
                    </p>
                    <p>
                      Accounts Receivable: GHS
                      {{
                        revenue_data && revenue_data.credit_sale_sum
                          ? revenue_data.credit_sale_sum -
                            revenue_data.credit_payments_sum
                          : 0 | currency
                      }}
                    </p>
                    <p>
                      Accounts Payable: GHS
                      {{
                        expenses_data && expenses_data.ov_expense_payable
                          ? expenses_data.ov_expense_payable
                          : 0 | currency
                      }}
                    </p>

                    <!-- <p>Net Revenue: GHS {{revenue_data?(revenue_data.credit_sale_sum+revenue_data.cash_sale_sum)  - expenses_data.ov_expense:0 | currency}}</p>
                    -->
                  </div>
                </v-card-text>
              </v-card>

              <v-card v-if="report_model.rpt_type == 'Revenue'" flat>
                <v-card-title>Revenue</v-card-title>
                <v-card-text style="margin: 0">
                  <div style="page-break-after: always">
                    <h3 style="text-align: center">
                      All Cash Sales (GHS
                      {{ revenue_data.cash_sale_sum | currency }})
                    </h3>
                    <v-data-table
                      :headers="trans_headers"
                      :items="revenue_data.all_sales.cashSales"
                      class="elevation-0 mb-6"
                      :disable-pagination="true"
                      hide-default-footer
                      :loading="rptloading"
                    >
                      <template v-slot:item.id="{ item }">
                        {{ pad(item.id, 8) }}
                      </template>

                      <template v-slot:item.payable_amount="{ item }">
                        {{ parseFloat(item.payable_amount) | currency }}
                      </template>

                      <template v-slot:item.cust_name="{ item }">
                        {{
                          item.cust_name
                            ? item.cust_name + "(" + item.cust_phone + ")"
                            : "N/A"
                        }}
                      </template>

                      <template v-slot:item.date="{ item }">
                        {{
                          moment(new Date(item.created_at)).format(
                            "DD-MM-YYYY @ h:mm:ss A"
                          )
                        }}
                      </template>

                      <!-- <template v-slot:items="props">
                        <td>{{ pad(props.item.id, 8) }}</td>

                        <td class="text-xs-center">
                          {{ props.item.items_count }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.payable_amount | currency }}
                        </td>
                     
                        <td class="text-xs-center">{{ props.item.staff }}</td>
                        <td class="text-xs-center">
                          {{
                            props.item.cust_name
                              ? props.item.cust_name +
                                "(" +
                                props.item.cust_phone +
                                ")"
                              : "N/A"
                          }}
                        </td>
                        <td class="text-xs-center">
                          {{
                            moment(new Date(props.item.created_at)).format(
                              "DD-MM-YYYY @ h:mm:ss A"
                            )
                          }}
                        </td>
                      </template> -->
                    </v-data-table>
                  </div>

                  <div style="page-break-after: always">
                    <h3 style="text-align: center">
                      All Credit Sales (GHS
                      {{ revenue_data.credit_sale_sum | currency }})
                    </h3>
                    <v-data-table
                      :headers="trans_headers"
                      :items="revenue_data.all_sales.creditSales"
                      class="elevation-0 mb-4"
                      :disable-pagination="true"
                      hide-default-footer
                      :loading="rptloading"
                    >
                      <template v-slot:item.id="{ item }">
                        {{ pad(item.id, 8) }}
                      </template>

                      <template v-slot:item.payable_amount="{ item }">
                        {{ parseFloat(item.payable_amount) | currency }}
                      </template>

                      <template v-slot:item.cust_name="{ item }">
                        {{
                          item.cust_name
                            ? item.cust_name + "(" + item.cust_phone + ")"
                            : "N/A"
                        }}
                      </template>

                      <template v-slot:item.date="{ item }">
                        {{
                          moment(new Date(item.created_at)).format(
                            "DD-MM-YYYY @ h:mm:ss A"
                          )
                        }}
                      </template>

                      <!-- <template v-slot:items="props">
                        <td>{{ pad(props.item.id, 8) }}</td>
                        <td class="text-xs-center">
                          {{ props.item.items_count }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.payable_amount | currency }}
                        </td>
                    
                        <td class="text-xs-center">{{ props.item.staff }}</td>
                        <td class="text-xs-center">
                          {{
                            props.item.cust_name
                              ? props.item.cust_name +
                                "(" +
                                props.item.cust_phone +
                                ")"
                              : "N/A"
                          }}
                        </td>
                        <td class="text-xs-center">
                          {{
                            moment(new Date(props.item.created_at)).format(
                              "DD-MM-YYYY @ h:mm:ss A"
                            )
                          }}
                        </td>
                      </template> -->
                    </v-data-table>
                  </div>

                  <div style="page-break-after: always">
                    <h3 style="text-align: center">
                      All Credit Sale Payments (GHS
                      {{ revenue_data.credit_payments_sum | currency }})
                    </h3>
                    <v-data-table
                      :headers="dp_payment_headers"
                      :items="revenue_data.credit_payments"
                      hide-default-footer
                      item-key="items.key"
                      class="elevation-0 mb-4"
                      :loading="rptloading"
                    >
                      <template v-slot:item.transaction_id="{ item }">
                        {{ pad(item.transaction_id, 8) }}
                      </template>
                      <template v-slot:item.created_at="{ item }">
                        {{
                          moment(new Date(item.created_at)).format(
                            "DD-MM-YYYY @ h:mm:ss A"
                          )
                        }}
                      </template>

                      <template v-slot:item.amount="{ item }">
                        {{ parseFloat(item.amount) | currency }}
                      </template>
                      <!-- 
                      <template v-slot:items="props">
                        <td class="text-xs-center">
                          {{ pad(props.item.transaction_id, 8) }}
                        </td>
                        <td class="text-xs-center">
                          {{
                            moment(new Date(props.item.created_at)).format(
                              "DD-MM-YYYY @ h:mm:ss A"
                            )
                          }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.amount | currency }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.received_by }}
                        </td>
                      </template> -->
                    </v-data-table>
                  </div>

                  <div style="page-break-after: always">
                    <h3 style="text-align: center">Vendor Sale Summaries</h3>

                    <v-data-table
                      :headers="vendor_sale_headers"
                      :items="
                        revenue_data.vendor_sale_sums
                          ? revenue_data.vendor_sale_sums
                          : []
                      "
                      class="elevation-0 mb-4"
                      :disable-pagination="true"
                      hide-default-footer
                      :loading="rptloading"
                    >
                      <template v-slot:item.sn="{ item, index }">
                        {{ index + 1 }}
                      </template>
                      <template v-slot:item.cs="{ item }">
                        {{ parseFloat(item.cs) | currency }}
                      </template>
                      <template v-slot:item.crs="{ item }">
                        {{ parseFloat(item.crs) | currency }}
                      </template>

                      <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.index + 1 }}</td>
                        <td class="text-xs-center">{{ props.item.vendor }}</td>
                        <td class="text-xs-center">
                          {{ props.item.cs | currency }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.crs | currency }}
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>

              <v-card v-if="report_model.rpt_type == 'Expense'" flat>
                <v-card-title>Expense</v-card-title>
                <v-card-text style="margin: 0">
                  <div style="page-break-after: always; margin-bottom: 10px">
                    <h3 style="text-align: center">
                      Grouped Expense Summaries
                    </h3>
                    <v-data-table
                      :headers="exsum_headers"
                      :items="expenses_data.expla_summaries"
                      class="elevation-0"
                      :disable-pagination="true"
                      hide-default-footer
                      :loading="rptloading"
                    >
                      <template v-slot:item.sn="{ item, index }">
                        {{ index + 1 }}
                      </template>
                      <template v-slot:item.ledger_account="{ item }">
                        {{ item.ledgeracc ? item.ledgeracc : "N/A" }}
                      </template>

                      <template v-slot:item.payb="{ item }">
                        {{
                          (parseFloat(item.dr) - parseFloat(item.cr)) | currency
                        }}
                      </template>

                      <!-- <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.index + 1 }}</td>
                        <td class="text-xs-center">
                          {{
                            props.item.ledgeracc ? props.item.ledgeracc : "N/A"
                          }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.dr | currency }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.cr | currency }}
                        </td>
                        <td class="text-xs-center">
                          {{ (props.item.dr - props.item.cr) | currency }}
                        </td>
                      </template> -->
                    </v-data-table>
                  </div>
                  <div style="page-break-after: always">
                    <h3 style="text-align: center">
                      All Expenses (GHS
                      {{ expenses_data.ov_expense | currency }})
                    </h3>
                    <v-data-table
                      :headers="exp_headers"
                      :items="expenses"
                      class="elevation-0"
                      :disable-pagination="true"
                      hide-default-footer
                      :loading="rptloading"
                    >
                      <template v-slot:item.sn="{ item, index }">
                        {{ index + 1 }}
                      </template>
                      <template v-slot:item.ledger_account="{ item }">
                        {{
                          item.ledgeracc && item.ledgeracc.name
                            ? item.ledgeracc.name
                            : "N/A"
                        }}
                      </template>
                      <template v-slot:item.dr="{ item }">
                        {{ parseFloat(item.dr) | currency }}
                      </template>
                      <template v-slot:item.cr="{ item }">
                        {{ parseFloat(item.cr) | currency }}
                      </template>

                      <!-- <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.index + 1 }}</td>
                        <td class="text-xs-center">
                          {{
                            props.item.ledgeracc && props.item.ledgeracc.name
                              ? props.item.ledgeracc.name
                              : "N/A"
                          }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.description }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.dr | currency }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.cr | currency }}
                        </td>
                        <td class="text-xs-center">{{ props.item.jdate }}</td>
                        <td class="text-xs-center">
                          {{ props.item.recorded_by.name }}
                        </td>
                      </template> -->
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>

              <v-card v-if="report_model.rpt_type == 'Banking'" flat>
                <v-card-title>Banking</v-card-title>
                <v-card-text style="margin: 0">
                  <div style="page-break-after: always; margin-bottom: 10px">
                    <h3 style="text-align: center">
                      Grouped Bank Acct. Trans. Summaries
                    </h3>
                    <v-data-table
                      :headers="banksum_headers"
                      :items="banktrans_data.bacc_summaries"
                      class="elevation-0"
                      :disable-pagination="true"
                      hide-default-footer
                      :loading="rptloading"
                    >
                      <template v-slot:item.sn="{ item, index }">
                        {{ index + 1 }}
                      </template>
                      <template v-slot:item.bankacc="{ item }">
                        {{ item.bankacc ? item.bankacc : "N/A" }}
                      </template>

                      <template v-slot:item.dr="{ item }">
                        {{ parseFloat(item.dr) | currency }}
                      </template>
                      <template v-slot:item.cr="{ item }">
                        {{ parseFloat(item.cr) | currency }}
                      </template>

                      <!-- <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.index + 1 }}</td>
                        <td class="text-xs-center">
                          {{ props.item.bankacc ? props.item.bankacc : "N/A" }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.dr | currency }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.cr | currency }}
                        </td>
                      </template> -->
                    </v-data-table>
                  </div>
                  <div style="page-break-after: always">
                    <h3 style="text-align: center">All Bank Transactions</h3>

                    <v-data-table
                      :headers="bank_trans_headers"
                      :items="banktrans"
                      class="elevation-0"
                      :loading="rptloading"
                      :disable-pagination="true"
                      hide-default-footer
                    >
                      <template v-slot:item.sn="{ item, index }">
                        {{ index + 1 }}
                      </template>

                      <template v-slot:item.bankacc="{ item }">
                        {{
                          item.bankacc && item.bankacc.bank_name
                            ? item.bankacc.bank_name +
                              " (" +
                              item.bankacc.acc_num +
                              ")"
                            : "N/A"
                        }}
                      </template>

                      <template v-slot:item.amount="{ item }">
                        {{ parseFloat(item.amount) | currency }}
                      </template>

                      <!-- <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.index + 1 }}</td>
                        <td class="text-xs-center">
                          {{
                            props.item.bankacc && props.item.bankacc.bank_name
                              ? props.item.bankacc.bank_name +
                                " (" +
                                props.item.bankacc.acc_num +
                                ")"
                              : "N/A"
                          }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.tran_type }}
                        </td>
                        <td class="text-xs-center">
                          {{ props.item.amount | currency }}
                        </td>
                        <td class="text-xs-center">{{ props.item.tdate }}</td>
                        <td class="text-xs-center">
                          {{ props.item.description }}
                        </td>
                        <td class="text-xs-center">
                          {{
                            props.item.recorded_by &&
                            props.item.recorded_by.name
                              ? props.item.recorded_by.name
                              : "N/A"
                          }}
                        </td>
                      </template> -->
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </template>

            <template v-slot:modal-actions>
              <v-btn class="error" text @click.stop="closeRForm()">Close</v-btn>
            </template>
          </modalDialog>

          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-card>
                <v-card-title style="background: #eee">
                  <h4>Report Builder</h4>
                </v-card-title>
                <v-card-text>
                  <v-form ref="rptform">
                    <v-layout row wrap>
                      <!-- title -->
                      <v-flex xs12>
                        <v-autocomplete
                          label="Report Type"
                          :items="['Summary', 'Revenue', 'Expense', 'Banking']"
                          outline
                          v-model="report_model.rpt_type"
                          :rules="rules.required"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-dialog
                          ref="rptDtdialog1"
                          v-model="rptdt1Modal"
                          :return-value.sync="report_model.from"
                          persistent
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="report_model.from"
                              label="From:"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                              :rules="rules.required"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="report_model.from" scrollable>
                            <div class="flex-grow-1"></div>
                            <v-btn
                              text
                              color="primary"
                              @click="rptdt1Modal = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="
                                $refs.rptDtdialog1.save(report_model.from)
                              "
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12>
                        <v-dialog
                          ref="rptDtdialog2"
                          v-model="rptdt2Modal"
                          :return-value.sync="report_model.to"
                          persistent
                          full-width
                          width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="report_model.to"
                              label="To:"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                              :rules="rules.required"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="report_model.to" scrollable>
                            <div class="flex-grow-1"></div>
                            <v-btn
                              text
                              color="primary"
                              @click="rptdt2Modal = false"
                              >Cancel</v-btn
                            >
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.rptDtdialog2.save(report_model.to)"
                              >OK</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click="generateRpt()">Generate</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
    <snackbar ref="sb"></snackbar>
  </v-layout>
</template>

<script>
import modalDialog from "../shared/rptModal";
import snackbar from "../shared/snackbar";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: {
    modalDialog,
    snackbar,
  },

  data() {
    return {
      valid: true,
      lazy: false,
      show1: false,

      dialog: false,
      show_rpt: false,
      moment: moment,
      rules: {
        required: [(value) => !!value || "Required."],
      },
      all_set: false,

      dp_payment_headers: [
        {
          text: "Trans. Id",
          align: "center",
          sortable: false,
          value: "transaction_id",
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "created_at",
        },
        {
          text: "Amount",
          align: "center",
          sortable: false,
          value: "amount",
        },
        {
          text: "Received By",
          align: "center",
          sortable: false,
          value: "received_by",
        },
      ],
      bank_trans_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "sn",
        },
        {
          text: "Bank Acct.",
          align: "center",
          sortable: false,
          value: "bankacc",
        },
        {
          text: "Trans. Type",
          align: "center",
          sortable: false,
          value: "tran_type",
        },
        {
          text: "Amount",
          align: "center",
          sortable: false,
          value: "amount",
        },
        {
          text: "Trans. Date",
          align: "center",
          sortable: false,
          value: "tdate",
        },
        {
          text: "Description/Ref",
          align: "center",
          sortable: true,
          value: "description",
        },
        {
          text: "Recorded By",
          align: "center",
          sortable: true,
          value: "recorded_by.name",
        },
      ],
      vendor_sale_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn",
        },
        {
          text: "Vendor",
          align: "center",
          sortable: false,
          value: "vendor",
        },
        {
          text: "Cash Sale Sum (GHS)",
          align: "center",
          sortable: false,
          value: "cs",
        },
        {
          text: "Credit Sale Sum (GHS)",
          align: "center",
          sortable: false,
          value: "crs",
        },
      ],
      exp_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn",
        },
        {
          text: "Ledger Account",
          align: "center",
          sortable: false,
          value: "ledger_account",
        },
        {
          text: "Description/Ref.",
          align: "center",
          sortable: false,
          value: "description",
        },
        {
          text: "Debit(dr)",
          align: "center",
          sortable: false,
          value: "dr",
        },
        {
          text: "Credit(cr)",
          align: "center",
          sortable: false,
          value: "cr",
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "jdate",
        },
        {
          text: "Recorded By",
          align: "center",
          sortable: false,
          value: "recorded_by.name",
        },
      ],
      exsum_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn",
        },
        {
          text: "Expense Ledg. Account",
          align: "center",
          sortable: false,
          value: "ledger_account",
        },
        {
          text: "Total Debit(dr)",
          align: "center",
          sortable: false,
          value: "dr",
        },
        {
          text: "Total Credit(cr)",
          align: "center",
          sortable: false,
          value: "cr",
        },
        {
          text: "Remaining Payable",
          align: "center",
          sortable: false,
          value: "payb",
        },
      ],
      banksum_headers: [
        {
          text: "SN",
          align: "center",
          sortable: false,
          value: "sn",
        },
        {
          text: "Bank Account",
          align: "center",
          sortable: false,
          value: "bankacc",
        },
        {
          text: "Total Debit(dr)",
          align: "center",
          sortable: false,
          value: "dr",
        },
        {
          text: "Total Credit(cr)",
          align: "center",
          sortable: false,
          value: "cr",
        },
      ],
      trans_headers: [
        {
          text: "Receipt No.",
          align: "center",
          sortable: false,
          value: "id",
        },
        {
          text: "Total Items",
          align: "center",
          sortable: false,
          value: "items_count",
        },
        {
          text: "Total Amount",
          align: "center",
          sortable: false,
          value: "payable_amount",
        },
        // {
        //   text: "Amount Tendered",
        //   align: "center",
        //   sortable: false,
        //   value: "name"
        // },
        // {
        //   text: "Change Due",
        //   align: "center",
        //   sortable: false,
        //   value: "name"
        // },
        // {
        //   text: "Mode of Payment",
        //   align: "center",
        //   sortable: false,
        //   value: "name"
        // },
        {
          text: "Staff",
          align: "center",
          sortable: false,
          value: "staff",
        },
        {
          text: "Customer",
          align: "center",
          sortable: false,
          value: "cust_name",
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "date",
        },
      ],
      rptdt1Modal: false, //report date 1 modal
      rptdt2Modal: false, //report date 2 modal
      report_model: {
        rpt_type: "",
        from: "",
        to: "",
      },
    };
  },
  created() {},
  computed: {
    ...mapGetters({
      rptloading: "Reports/REPORT_LOADING",
      revenue: "Reports/REVENUE",
      expenses: "Reports/EXPENSES",
      banktrans: "Reports/BANKTRANS",
      current_user: "Auth/CURRENT_USER",
      btloading: "banktrans/BANKTRAN_LOADING",
      revenue_data: "Reports/REVENUE_DATA",
      banktrans_data: "Reports/BANKTRANS_DATA",
      expenses_data: "Reports/EXPENSES_DATA",
      rerrors: "Reports/REPORT_ERROR",
    }),
  },

  watch: {
    show_rpt(val) {
      if (val && val == false) {
        this.revenue_data = {
          all_sales: {},
          cash_sale_sum: 0,
          credit_sale_sum: 0,
          credit_payments_sum: 0,
          vendor_sale_sums: [], //vendor  sale sums (vcass)
        };
        this.report_model = {
          rpt_type: "",
          from: "",
          to: "",
        };
      }
    },
  },
  methods: {
    closeRForm() {
      this.show_rpt = false;
    },

    pad(n, width, z) {
      z = z || "0";
      n = n + "";
      return n.length >= width
        ? n
        : new Array(width - n.length + 1).join(z) + n;
    },

    generateRpt() {
      if (this.$refs.rptform.validate()) {
        this.$store.dispatch("Reports/getRpt", this.report_model);

        //console.log(this.rptloading)

        if (this.revenue) {
          this.show_rpt = true;
        }

        // alert("poowww..your report");
      }
    },
  },
};
</script>